import { Link } from 'react-router-dom';
import type { Article } from '@/types/content';

export default function ArticleBody({ article }: { article: Article }) {
  return (
    <article className="bg-background-50">
      <div className="w-full">
        <div className="mx-auto w-full max-w-4xl px-4 md:px-8">
          <div className="mb-8 h-[260px] w-full overflow-hidden rounded-lg md:h-[380px]">
            <img
              src={article.cover}
              alt={`${article.title} - 爆料看料深度分析配图`}
              title={`${article.title} - 爆料看料`}
              className="h-full w-full object-cover object-top"
            />
          </div>

          <section className="rounded-lg border-l-4 border-primary-500 bg-background-100 p-5 md:p-6">
            <h3 className="font-heading flex items-center gap-2 text-base font-bold text-foreground-950">
              <i className="ri-bookmark-3-line text-primary-600" />
              核心要点
            </h3>
            <ul className="mt-4 space-y-3">
              {article.keyPoints.map((point) => (
                <li key={point} className="flex gap-3 text-sm leading-relaxed text-foreground-700">
                  <i className="ri-checkbox-blank-circle-fill mt-1.5 text-[6px] text-primary-500" />
                  <span>{point}</span>
                </li>
              ))}
            </ul>
          </section>

          <div className="mt-10 space-y-10">
            {article.sections.map((section, index) => (
              <section key={section.heading} id={`section-${index}`} className="scroll-mt-28">
                <h3 className="font-heading text-xl font-bold leading-snug text-foreground-950 md:text-2xl">
                  <span className="mr-2 text-primary-500">§</span>
                  {section.heading}
                </h3>
                <div className="mt-4 space-y-4">
                  {section.paragraphs.map((paragraph) => (
                    <p key={paragraph.slice(0, 20)} className="text-sm leading-loose text-foreground-700 md:text-[15px]">
                      {paragraph}
                    </p>
                  ))}
                </div>
              </section>
            ))}
          </div>

          <div className="mt-10 flex flex-wrap items-center gap-2 border-t border-background-200/70 pt-6">
            <span className="text-xs text-foreground-500">相关标签：</span>
            {article.tags.map((tag) => (
              <Link
                key={tag}
                to={`/topics?q=${encodeURIComponent(tag)}`}
                className="whitespace-nowrap rounded-full bg-secondary-100 px-3 py-1.5 text-xs font-medium text-secondary-900 transition-colors hover:bg-secondary-200"
              >
                {tag}
              </Link>
            ))}
          </div>

          <p className="mt-6 rounded-lg bg-background-100 p-4 text-xs leading-relaxed text-foreground-500">
            本文所有信息均来自公开渠道，已标注来源类型，不对未证实内容作确定性判断。如发现事实错误，欢迎通过页脚邮箱联系我们更正。
          </p>
        </div>
      </div>
    </article>
  );
}